export default {
    props: {
        groupableEnabled: {
            type: Boolean,
            default: undefined,
            kComposite: 'groupable.enabled'
        },
        groupableShowFooter: {
            type: Boolean,
            default: undefined,
            kComposite: 'groupable.showFooter'
        },
        groupableSortCompare: {
            type: Function,
            default: undefined,
            kComposite: 'groupable.sort.compare'
        },
        groupableSortDir: {
            type: String,
            default: undefined,
            kComposite: 'groupable.sort.dir'
        },
        groupableMessagesEmpty: {
            type: String,
            default: undefined,
            kComposite: 'groupable.messages.empty'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-grid-vue-wrapper/src/KendoGrid/Groupable.js